import AzureSearchApiSettings from './azuresearch.apisettings';
import AzureSearchRequest from './azuresearch.searchrequest';
import AzureSearchGui from './azuresearch.searchgui';
import AzureSearchFacetDefinition from './azuresearch.facetdefinition';
import AzureSearchSearchSettings from './azuresearch.searchsettings';
import AzureSearchApi from './azuresearch.api';

export default {
  AzureSearchApiSettings,
  AzureSearchRequest,
  AzureSearchGui,
  AzureSearchFacetDefinition,
  AzureSearchSearchSettings,
  AzureSearchApi
};
